
<div class="toggle_payment_view">
  <mat-button-toggle-group
name="fontStyle"
aria-label="Font Style"
color="accent"
class="m-3"

>
<mat-button-toggle value="list" color="accent" (click)="onList()"
  ><mat-icon class="example-tab-icon"
    >list</mat-icon
  ></mat-button-toggle
>
<mat-button-toggle value="grid" (click)="onGrid()"
  ><mat-icon class="example-tab-icon"
    >view_module</mat-icon
  ></mat-button-toggle
>
</mat-button-toggle-group>
<div>
  <button *ngIf="listView" class="default_secondary-btn" (click)="onViewRange()">View Range</button>
</div>
</div>

    <ng-container *ngIf="gridView">
 <div class="incidence_select_all">
    <div class="detail_entered"  *ngFor="let incidentitem of incident" (click)="onView(incidentitem)">
      <div class="the_details" (click)="onView(incidentitem)">
        <h2 class="name">Incident Name:
          <span class="incident_num"> {{incidentitem?.IncidentName}}</span>
          <span class="incident_num"> {{incidentitem?.IncidentNotificationId}}</span>
        </h2>
        <div class="other_detail">
          <p class="entry">Incident Date: <span class="sub_element">{{incidentitem?.IncidentDate | date}}</span></p>
          <p class="entry">JIV Date: <span class="sub_element">{{incidentitem?.JIVDate | date}}</span></p>
          <p class="entry">JIV Survey Date: <span class="sub_element">{{incidentitem?.JIVSurveyDate | date}}</span></p>
          <p class="entry">Area of impact: <span class="sub_element">{{incidentitem?.TotalAreaOfImpact}} {{getUOMName(incidentitem.UomId)}}</span></p>
          <p class="entry">Qty Spilled: <span class="sub_element">{{incidentitem?.QtySpilled}} {{getUOMName(incidentitem.UomId)}}</span></p>
          <p class="entry">Cause of Incident: <span class="sub_element">{{incidentitem?.CauseOfIncident}}</span></p>
          <p class="entry">Nature of Pollution: <span class="sub_element">{{incidentitem?.NatureOfPolution}}</span></p>
        </div>
      </div>
    </div>

  </div>
</ng-container>

  <div class="card mt-3 " *ngIf="listView">
    <form [formGroup]="rangeForm" class="mode">
      <div class="call" *ngIf="isViewRange" style="display: flex; flex-direction: row; padding-top: 1.5rem; margin-bottom: 1rem;">
        <div class="the_input" style="margin-right: 1.5rem; margin-left: 1.5rem;">
          <label for="">From Date</label>
          <input type="date" formControlName="StartDate" class="default_input" />
        </div>
        <div class="the_input">
          <label for="">To Date</label>
          <input type="date" formControlName="EndDate" class="default_input" />
        </div>
        <div class="down" style="margin-top: 1rem; margin-left: 1.5rem;">
          <button class="default_primary-button" type="submit" (click)="onSearch()">Search</button>
        </div>
      </div>
    </form>
    <div class="btn_hold" *ngIf="incident?.length">
      <button class="print_btn" style="float: right; margin-right: 1rem;" [useExistingCss]="true"  printSectionId="demo"  ngxPrint>Generate Report</button>
    </div>
    <div id="demo" class="print dontshow">
    <div class="table-responsive">
    <table class="table table-hover" >
      <thead>
        <tr>
          <th scope="col">S/N</th>
          <th scope="col">Incident Name</th>
          <th scope="col">Incident Number</th>
          <th scope="col">Incident Date</th>
          <th scope="col">JIV Date</th>
          <th scope="col">JIV Survey Date</th>
          <th scope="col">Area of impact</th>
          <th scope="col">Qty Spilled</th>
          <th scope="col">Cause of Incident</th>
          <th scope="col">Nature of Pollution</th>
          <th scope="col">Remarks</th>
          <th scope="col" class="no-print">Action</th>
        </tr>
      </thead>
      <tbody >
        <tr  *ngFor="let incidentitem of incident; index as i" (click)="onView(incidentitem)"
        style="cursor: pointer;"
        >
          <th scope="row">{{i + 1}}</th>
          <td class="entry"> {{incidentitem?.IncidentName}}</td>
          <td class="entry"> {{incidentitem?.IncidentNotificationId}}</td>
          <td class="entry">{{incidentitem?.IncidentDate | date}}</td>
          <td class="entry">{{incidentitem?.JIVDate | date}}</td>
          <td class="entry">{{incidentitem?.JIVSurveyDate | date}}</td>
          <td class="entry">{{incidentitem?.TotalAreaOfImpact}} {{getUOMName(incidentitem.UomId)}}</td>
          <td class="entry">{{incidentitem?.QtySpilled}} {{getUOMName(incidentitem.UomId)}}</td>
          <td class="entry">{{incidentitem?.CauseOfIncident}}</td>
          <td class="entry">{{incidentitem?.NatureOfPolution}}</td>
          <td class="entry">{{incidentitem?.Remarks}}</td>
          <td class="entry no-print" (click)="$event.stopImmediatePropagation()">
            <button class="delete_icon trash" style="background:none; border:none; outline: none; color:rgb(174, 52, 52)" (click)="deleteIncident(incidentitem.id)">
              <em class="ti-trash"> </em>
            </button>
          </td>
        </tr>

      </tbody>
    </table>
  </div>
</div>
  </div>


